import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { BodyTextMedium, ComponentTextSmall } from '../Typography/Typography';
import { DeprecatedReactRouterLink as Link } from '../Link/DeprecatedReactRouterLink';
import { Heading } from './Heading';
import * as styles from './DeprecatedInlineMessage.module.scss';
export var InlineMessageTestID;
(function (InlineMessageTestID) {
    InlineMessageTestID["Container"] = "InlineMessageTestID.Container";
    InlineMessageTestID["TextLink"] = "InlineMessageTestID.TextLink";
})(InlineMessageTestID || (InlineMessageTestID = {}));
/**
 * @deprecated Use {@link CalloutInline}
 */
export const DeprecatedInlineMessage = ({ icon, iconColor, startIconUrl, heading, message, image, alignment, action, secondaryAction, children, }) => {
    const renderAction = (action) => {
        if ('href' in action) {
            return (_jsx("a", { className: styles.action, href: action.href, target: action.target ?? '_blank', rel: "noopener noreferrer", "data-testid": InlineMessageTestID.TextLink, children: action.text }));
        }
        if ('to' in action) {
            return (_jsx(Link, { to: action.to, "data-testid": InlineMessageTestID.TextLink, style: { textDecoration: 'underline' }, children: _jsx(ComponentTextSmall, { fontColor: "blue55", marginTop: 4, children: action.text }) }));
        }
    };
    const renderMessageActions = (action) => {
        if (!secondaryAction) {
            return renderAction(action);
        }
        return (_jsxs(_Fragment, { children: [renderAction(action), renderAction(secondaryAction)] }));
    };
    const compAlignment = alignment === 'center' ? 'Center' : 'Start';
    const containerStyle = clsx(styles.container, styles[`container${compAlignment}`]);
    const textContainerStyle = clsx(styles.textContainer, styles[`textContainer${compAlignment}`]);
    return (_jsxs("div", { className: containerStyle, children: [image && (_jsx("div", { className: styles.imageContainer, children: _jsx("img", { className: styles.circleImage, alt: "", src: image }) })), _jsxs("div", { className: textContainerStyle, children: [heading && (_jsx(Heading, { heading: heading, icon: icon, iconColor: iconColor, startIconUrl: startIconUrl })), _jsx(BodyTextMedium, { fontColor: "gray65", children: message }), action ? renderMessageActions(action) : children] })] }));
};
